import { createFileRoute } from '@tanstack/react-router'

import { WithdrawalFunds } from '@/pages/withdrawal-funds'

export const Route = createFileRoute('/withdrawal/funds')({
    component: WithdrawalFunds,
})
